<template>
  <div class="album-box">
    <div class="body">
      <el-empty v-if="!dataList||dataList.length===0" description="暂无数据"></el-empty>
      <viewer class="list-box" :images="dataList" ref="viewer" @inited="inited">
        <template #default="scope">
          <div class="file-box" v-for="(file, index) in dataList" :key="index">
            <img :src="file" class="img"/>
            <div class="opt-box">
              <i class="el-icon-delete"></i>
              <i class="el-icon-zoom-in" @click="show"></i>
            </div>
            <!-- <div class="label">{{ file.name }}</div> -->
          </div>
        </template>
      </viewer>
    </div>
  </div>
</template>
<script>
export default {
  name: "order-imgs",
  props: {
    agreementId: {
      type: String,
      default: "",
    },
  },
  watch: {
    agreementId: {
      handler: function(newVal) {
        this.getDataList();
      },
      immediate: true,
    },
  },
  data() {
    return {
      dataList: [],
      queryForm: {},
    };
  },

  methods: {
    inited(viewer) {
      this.$viewer = viewer;
    },
    show() {
      this.$viewer.show();
    },
    getDataList() {
      if (!this.agreementId) {
        this.dataList = [];
        return;
      }
      console.log("this.agreementId", this.agreementId);
      this.$http
        .get(`/trade/order/imgs/${this.agreementId}`)
        .then(({ data: res }) => {
          if (res.code != 0) {
            return this.$message.error(res.msg);
          }
          if (res.data) {
            let imgs = res.data.substr(0, res.data.length - 1);
            this.dataList = imgs.split(",");
          }
        })
        .catch((e) => {
          console.log(`getDataList`, e);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.album-box {
  display: flex;
  background-color: #fff;
  height: calc(100vh - 75px);
  padding: 20px 20px;
  .dir-box {
    width: 300px;
    flex: none;
  }
  .body {
    flex: 1;
    .opt-box {
      display: flex;
      //   justify-content: flex-end;
      height: 60px;
    }
    .list-box {
      display: flex;
      flex-wrap: wrap;
      margin-right: -10px;
      height: calc(100% - 60px);
      overflow-x: hidden;
      overflow-y: auto;
      .file-box:hover {
        .opt-box {
          display: flex;
        }
      }
      .file-box {
        border: solid 1px #f1f4f5;
        border-radius: 10px;
        overflow: hidden;
        width: 150px;
        height: 150px;
        margin: 0 10px 10px 0;
        position: relative;
        .opt-box {
          cursor: pointer;
          position: absolute;
          width: 100%;
          height: 100%;
          background-color: rgba($color: #000000, $alpha: 0.3);
          display: none;
          align-items: center;
          justify-content: center;
          top: 0;
          left: 0;
          color: #fff;
          font-size: 28px;
          i {
            margin: 0 4px 0 4px;
            cursor: pointer;
          }
        }
        .img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .label {
          position: absolute;
          bottom: 0;
          width: 100%;
          left: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          height: 30px;
          background-color: rgba($color: #000000, $alpha: 0.5);
          cursor: pointer;
        }
      }
    }
  }
}
</style>
